//DARK MODE - Midnight Tangerine Palette
const midnight = '#0A0F1D';      // Deep obsidian navy page background
const slate = '#131B2E';         // Slate navy for sections / cards
const twilight = '#1E293B';      // Dark slate for backgrounds / accents
const tangerine = '#FF8A5C';     // Signature warm tangerine orange accent
const sky = '#93C5FD';           // Soft, calm blue secondary accent (less bright)
const iceWhite = '#F8FAFC';      // Crisp ice white headers / title text
const softSlate = '#CBD5E1';     // Soft slate paragraph text / body text


export default {
    colors: {
        //Scroll Bar colors
        TRACK: midnight,
        THUMB: tangerine,

        //NavBar colors
        NAV_BAR_HOVER: tangerine,
        NAV_BAR_HEADER: softSlate,
        NAV_BAR_ACTIVE: tangerine,
        NAV_BAR_SHADOW_SAFARI: twilight,
        NAV_BAR_SHADOW: twilight,
        NAV_BAR_BACKGROUND: midnight,

        //Contact page colors
        CONTACT_MEDIUM: iceWhite,
        CONTACT_MEDIUM_HOVER: tangerine,
        CONTACT_HEADER: tangerine,
        LINKEDIN: tangerine,
        EMAIL: slate,
        EMAIL_BACKGROUND: tangerine,

        //Logo colors
        LOGO_BACKGROUND_HOVER: twilight,
        LOGO_BACKGROUND: midnight,
        LOGO_TEXT: iceWhite,
        LOGO_TEXT_HOVER: tangerine,
        LOGO_EMPHASIS: tangerine,
        LOGO_EMPHASIS_HOVER: iceWhite,
        LOGO_BACKGROUND_SAFARI: midnight,

        //Page backgrounds
        TITLE_BACKGROUND: twilight,
        SUBTITLE_BACKGROUND: slate,
        ACCENT_BACKGROUND: tangerine,
        PAGE_BACKGROUND: midnight,
        CONTACT_BACKGROUND: slate,
        FOOTER_BACKGROUND: slate,

        //Text
        HEADER_TEXT: tangerine,
        TITLE_TEXT: iceWhite,
        FOOTER_TEXT: softSlate,
        PARAGRAPH_TEXT: softSlate,

        //TOGGLE
        TOGGLE: softSlate,
        TOGGLE_HOVER: tangerine,

        //ABOUT
        RESUME_ITEM_TITLE: tangerine,
        RESUME_ITEM_SUBTITLE: sky,
        SIDEBAR: tangerine,
        PHOTO_SHADOW: tangerine,
        LINK: tangerine,
        LINK_HOVER: sky,

        //PROJECTS
        PROJECT_PREVIEW_OVERLAY: slate,
        PROJECT_PREVIEW_OVERLAY_TEXT: iceWhite,
        PROJECT_PREVIEW_TEXT_SHADOW: midnight,
        PROJECT_PREVIEW_BORDER: slate,
    }
}